var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, Fragment, useCallback, forwardRef } from "react";
import Drop from "../drop";
import useClonedChildren from "../mixins/useClonedChildren";
import getAncestors from "../mixins/getAncestors";
import useForwardRef from "../../../hooks/use-forward-ref";
import useToggle from "../../../hooks/use-toggle";
import MenuButton from "./menuButton";
import Dropdown from "./dropdown";
import DropdownItem from "./dropdownItem";
var defaultRenderDropdown = function (props) { return React.createElement(Dropdown, __assign({}, props)); };
var defaultRenderItem = function (props) {
    var key = props.item.value || props.item.label;
    return React.createElement(DropdownItem, __assign({ key: key }, props));
};
var Menu = forwardRef(function (_a, parentRef) {
    var value = _a.value, onChange = _a.onChange, onOpen = _a.onOpen, onClose = _a.onClose, _b = _a.closeOnClick, closeOnClick = _b === void 0 ? true : _b, _c = _a.open, initialOpen = _c === void 0 ? false : _c, _d = _a.icon, icon = _d === void 0 ? null : _d, label = _a.label, _e = _a.caret, caret = _e === void 0 ? true : _e, children = _a.children, dropProps = _a.dropProps, items = _a.items, _f = _a.renderItem, renderItem = _f === void 0 ? defaultRenderItem : _f, _g = _a.renderDropdown, renderDropdown = _g === void 0 ? defaultRenderDropdown : _g, animation = _a.animation, rest = __rest(_a, ["value", "onChange", "onOpen", "onClose", "closeOnClick", "open", "icon", "label", "caret", "children", "dropProps", "items", "renderItem", "renderDropdown", "animation"]);
    var _h = useToggle(initialOpen, { on: onOpen, off: onClose }), isOpen = _h[0], toggleIsOpen = _h[1], open = _h[2], close = _h[3];
    var _j = useForwardRef(parentRef), ref = _j[0], setRef = _j[1];
    var onItemClick = useCallback(function (nextValue) {
        if (onChange)
            onChange(nextValue);
        if (closeOnClick)
            close();
    }, [onChange]);
    var onClickOutside = useCallback(function (event) {
        if (ref.current !== event.target &&
            !getAncestors(event.target).some(function (node) { return node === ref.current; })) {
            close();
        }
    }, []);
    var clonedChildren = useClonedChildren(children, setRef, __assign({ onClick: toggleIsOpen, "aria-haspopup": "listbox", "aria-expanded": isOpen, open: isOpen }, rest));
    var menuLabel = useMemo(function () {
        if (label)
            return label;
        if (clonedChildren)
            return clonedChildren;
        var item = items.find(function (i) { return i.value === value; });
        return item === null || item === void 0 ? void 0 : item.label;
    }, [label, clonedChildren, items, value]);
    return (React.createElement(Fragment, null,
        clonedChildren,
        !clonedChildren && (React.createElement(MenuButton, __assign({ ref: setRef, icon: icon, label: menuLabel, caret: caret, onClick: toggleIsOpen, open: isOpen }, rest))),
        isOpen && ref.current && (React.createElement(Drop, __assign({ target: ref.current, onEsc: close, onClickOutside: onClickOutside, animation: animation }, dropProps), renderDropdown({ value: value, onItemClick: onItemClick, items: items, renderItem: renderItem })))));
});
export default Menu;
